import React, { Component } from "react";
import { connect } from "react-redux";
import Autosuggest from "react-autosuggest";
import axios from "axios";
import { setTerm } from "../actions/searchActions";

import "./SearchAutoComplete.css";

const getSuggestionValue = suggestion => suggestion;

const renderSuggestion = suggestion => <div>{suggestion}</div>;

class SearchAutoComplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      suggestions: []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
    this.props.termChangeHandler(newValue);
  };

  onSuggestionsFetchRequested = ({ value }) => {
    if (value && value.length >= 3) {
      axios
        .post("/api/pages/autocomplete", { term: value })
        .then(result => {
          if (result.status === 200 && result.data.suggestions) {
            this.setState({
              suggestions: result.data.suggestions
            });
          } else {
            this.setState({
              suggestions: []
            });
          }
        })
        .catch(error => {
          console.log("error");
          console.log(error);
        });
    }
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;

    const inputProps = {
      placeholder: "הקלד נושא לחיפוש",
      value,
      onChange: this.onChange
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}
const mapStateToProps = state => {
  return {
    value: state.searchData.searchTerm
  };
};

const mapDispatchToProps = dispatch => {
  return {
    termChangeHandler: value => dispatch(setTerm(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchAutoComplete);
